import { FunctionComponent } from 'react';

// import { loginAtom, renew_sign_in } from '../../lib/auth';
// import { useAtom } from 'jotai';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Chip
} from '@mui/material';

import { UserTag } from '../../../models/UserTag';

type Props = {
  tag: UserTag;
  onClick?: () => void;
  sx?: any;
};

export const TagChip: FunctionComponent<Props> = ({tag, onClick, sx}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();

  return (<Chip
    label={tag.name}
    onClick={onClick}
    sx={{
      backgroundColor: tag.bg_colour || theme.palette.primary.main,
      marginRight: 1,
      "& > span": {
        color: tag.colour || theme.palette.tertiary?.main,
      },
      ...sx
    }}
  />);
}
